import { useNavigate, useLocation, Link } from "react-router-dom";
import Modal from "../Modal/Modal";
import "../Modal/Modal.css";
import { useState, useEffect } from "react";

const BuyerInitiatedPopupMessage = ({ element }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleSubmitEvt = () => {
    setIsOpen(false);
    navigate("/transferbuyer", {
      state: { from: location },
      replace: false,
    });
  };

  const handleCancelEvt = () => {
    setIsOpen(false);
    navigate("/", {
      state: { from: location },
      replace: false,
    });
  };

  const handleBoatRegiEvt = () => {
    setIsOpen(false);
    navigate("/boatregistration", {
      state: { from: location },
      replace: false,
    });
  };

  return (
    <>
      {isOpen ? (
        <Modal
          title="Transfer of Registration of a Vessel – Buyer"
          titleSize="1.25rem"
          submitBtn="Continue"
          setOpenModal={setIsOpen}
          submitClkEvent={handleSubmitEvt}
          cancelClkEvent={handleCancelEvt}
          cancelBtn="Cancel"
        >
          <div>
            <p>
              This form can only be used to transfer the registration of a
              vessel currently registered in Tasmania or expired for less than
              12 months.
            </p>
            <p>
              To register a vessel from interstate, or a Tasmanian vessel
              expired more than 12 months, you must register it as a new vessel{" "}
              <Link to="/boatregistration" onClick={handleBoatRegiEvt}>
                here
              </Link>
            </p>
          </div>
        </Modal>
      ) : (
        <>{element}</>
      )}
    </>
  );
};

export default BuyerInitiatedPopupMessage;
